import type { ProfileDto } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";
import type {
    ContactDetails,
    ContactsSearchSortBy,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import {
    CONTACTS_SEARCH_TABLE_INITIAL_PAGE,
    CONTACTS_SEARCH_TABLE_PAGE_SIZE,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/table";

export type CompanyAnalysisContactsState = {
    // Contacts table
    tableSearchText: string;
    tableCurrentPage: number;
    tablePageSize: number;
    // Employee location filter
    selectedEmployeeLocationIds: readonly number[];
    // Employee profiles filter
    selectedProfileId: string | null;
    isProfileModalOpened: boolean;
    profileForEdit: ProfileDto | null;
    // Contact details filter
    contactDetails: ContactDetails;
    sortBy?: ContactsSearchSortBy;
};

const initialCompanyAnalysisContactsState: CompanyAnalysisContactsState = {
    tableSearchText: "",
    tableCurrentPage: CONTACTS_SEARCH_TABLE_INITIAL_PAGE,
    tablePageSize: CONTACTS_SEARCH_TABLE_PAGE_SIZE,
    selectedEmployeeLocationIds: [],
    selectedProfileId: null,
    isProfileModalOpened: false,
    profileForEdit: null,
    contactDetails: {},
};

export default initialCompanyAnalysisContactsState;
